import { validaCpf } from 'utils/genericFunctions';
import * as Yup from 'yup';

export interface IFormConsultaNomeSocial {
	cpf: string;
	usuario: string;
	senha: string;
}

export const initialValues: IFormConsultaNomeSocial = {
	cpf: '',
	usuario: '',
	senha: '',
};

export const schema = Yup.object<IFormConsultaNomeSocial>().shape({
	cpf: Yup.string()
		.required('Campo Obrigatório: CPF.')
		.test({
			name: 'cpfValidation',
			exclusive: true,
			message: 'CPF digitado inválido.',
			test: value => validaCpf(value),
		}),
});
